import { getTabSpaceHeaders } from "@/utils/tabSpace"

export const COOKIE_AUTH_ENABLED =
  process.env.NEXT_PUBLIC_AUTH_USE_COOKIE === "true"

export const CSRF_COOKIE_NAME =
  process.env.NEXT_PUBLIC_AUTH_CSRF_COOKIE_NAME ?? ""

export const CSRF_HEADER_NAME =
  process.env.NEXT_PUBLIC_AUTH_CSRF_HEADER_NAME ?? ""

const requirePublicEnvValue = (name: string, value: string): string => {
  if (!value) {
    throw new Error(`${name} must be configured when cookie auth is used`)
  }

  return value
}

const getCsrfCookieName = () =>
  requirePublicEnvValue("NEXT_PUBLIC_AUTH_CSRF_COOKIE_NAME", CSRF_COOKIE_NAME)

const getCsrfHeaderName = () =>
  requirePublicEnvValue("NEXT_PUBLIC_AUTH_CSRF_HEADER_NAME", CSRF_HEADER_NAME)

export function getCookie(name: string): string | null {
  if (typeof document === "undefined") return null

  const value = `; ${document.cookie}`
  const parts = value.split(`; ${name}=`)
  if (parts.length !== 2) return null

  return decodeURIComponent(parts.pop()!.split(";").shift() ?? "")
}

export function getCsrfHeaders(): Record<string, string> {
  if (!COOKIE_AUTH_ENABLED) return {}

  const token = getCookie(getCsrfCookieName())
  return token ? { [getCsrfHeaderName()]: token } : {}
}

// export function getAuthFetchOptions(options: RequestInit = {}): RequestInit {
//   return {
//     ...options,
//     credentials: COOKIE_AUTH_ENABLED ? "include" : options.credentials,
//     headers: {
//       ...getCsrfHeaders(),
//       ...(options.headers ?? {}),
//     },
//   }
// }

export function getAuthFetchOptions(
  token_from_storage: string,
  options: RequestInit = {},
): RequestInit {
  const headers: Record<string, string> = {
    ...(COOKIE_AUTH_ENABLED
      ? getCsrfHeaders()
      : { Authorization: `Bearer ${token_from_storage}` }),
    // The API resolves the user's active space (and thus space_user) from this
    // header; without it, raw fetches fall back to the token's default space,
    // which 403s storage access for multi-space users working in another space.
    ...getTabSpaceHeaders(),
    ...(options.headers as Record<string, string> | undefined),
  }

  return {
    ...options,
    credentials: COOKIE_AUTH_ENABLED ? "include" : options.credentials,
    headers,
  }
}

export function hasCookieAuthSignal(): boolean {
  return COOKIE_AUTH_ENABLED && !!getCookie(getCsrfCookieName())
}
